import type { NitroFetchOptions, NitroFetchRequest, TypedInternalResponse } from 'nitropack'

export const useDedupeFetch = <T = unknown>(
  request: NitroFetchRequest,
  opts: NitroFetchOptions<NitroFetchRequest> & { key?: string } = {},
): Promise<TypedInternalResponse<NitroFetchRequest, T>> => {
  const cache = useUserCache().dedupeCache
  const key = opts.key
  if (key && cache.has(key)) return cache.get(key)

  const requestPromise = $fetch<T>(request, opts)
  if (!key) return requestPromise

  const pending = requestPromise.finally(() => {
    // An invalidation may have replaced this request while it was in flight.
    if (cache.get(key) === pending) cache.delete(key)
  })
  cache.set(key, pending)
  return pending
}
